<template>
   <!-- The ids recordForm / recordFormModal are used by $validateForm, $enableModalEnterSave and Alt+N -->
   <form id="recordForm" novalidate @submit.prevent="$emit('save')">
      <div id="recordFormModal" class="modal fade" tabindex="-1" data-bs-focus="false">
         <!-- scrollable: title and buttons stay, only the fields scroll. fullscreen-sm-down: whole screen on phones -->
         <div :class="['modal-dialog', 'modal-dialog-scrollable', 'modal-fullscreen-sm-down', 'record-form-dialog', size ? 'modal-' + size : '']">
            <div class="modal-content bg-sa-modal-content">
               <div class="modal-body">
                  <div class="card bg-sa-card">
                     <div class="card-header bg-sa-card-header d-flex justify-content-between align-items-center">
                        <span><i v-if="titleIcon" :class="[titleIcon, 'me-2']"></i>{{ title }}</span>
                        <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
                     </div>
                     <div class="card-body bg-sa-card-body m-0 p-1">
                        <!--AlertMessage (only when the page passes its alert) -->
                        <AlertComponent
                           v-if="alert && alert.pageOrModal == 'modal'"
                           :alertstatus="alert.alertstatus"
                           :message="alert.alertMessage"
                           :type="alert.alertType"
                        />

                        <!-- The page's own fields -->
                        <slot />
                     </div>
                  </div>
               </div>
               <div class="modal-footer bg-sa-modal-footer">
                  <div class="d-flex justify-content-end">
                     <!-- While saving: spinner + "Saving…" on the button itself (no pop-up over the form) -->
                     <button type="submit" class="btn btn-primary me-2" :disabled="isSaving">
                        <span v-if="isSaving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        <i v-else :class="isEditing ? 'fa fa-edit me-1' : 'fa fa-save me-1'"></i>
                        {{ isSaving ? (isEditing ? 'Updating…' : 'Saving…') : (isEditing ? 'Update' : 'Save') }}
                     </button>
                     <button v-if="showSample && !isEditing && $showSampleButton" @click="$emit('sample')" type="button" class="btn btn-info me-2">
                        <i class="fa fa-database me-1"></i> Sample
                     </button>
                     <button v-if="showReset" @click="$emit('reset')" type="button" class="btn btn-secondary me-2">
                        <i class="fa fa-undo me-1"></i>Reset
                     </button>
                     <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Close</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </form>
</template>

<script>
import AlertComponent from "../ui/AlertComponent.vue";

export default {
   name: "RecordFormModal",
   components: { AlertComponent },
   props: {
      title: { type: String, default: "" },
      titleIcon: { type: String, default: "bi bi-person" },
      isEditing: { type: Boolean, default: false },
      isSaving: { type: Boolean, default: false },
      alert: { type: Object, default: null },
      size: { type: String, default: "" },        // "", "lg" or "xl"
      showSample: { type: Boolean, default: true },
      showReset: { type: Boolean, default: true },
   },
   emits: ["save", "sample", "reset"],
};
</script>
